export const SET_MODAL_DATA = 'SET_MODAL_DATA';
export const SET_EDITABLE_ITEM = 'SET_EDITABLE_ITEM';

export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS';
export const GET_CATEGORIES_FAILURE= 'GET_CATEGORIES_FAILURE';

export const SET_CURRENT_RESTAURANT = 'SET_CURRENT_RESTAURANT';

export const GET_STRIPE_LINK_REQUEST = 'GET_STRIPE_LINK_REQUEST';

export const RESET_STORE = 'RESET_STORE';
